var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "white-noise-audio" }, [
    _c("audio", {
      ref: "audio1",
      staticClass: "white-noise-audio",
      attrs: { "webkit-playsinline": "" },
      on: { pause: _vm.onPause, play: _vm.onPlay },
    }),
    _c("audio", {
      ref: "audio2",
      staticClass: "white-noise-audio",
      attrs: { "webkit-playsinline": "" },
      on: { pause: _vm.onPause, play: _vm.onPlay },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }